/**
 * Společné utility pro checkout moduly (footer).
 */

export function safeGetShoptetDataLayer() {
  try {
    if (typeof getShoptetDataLayer === 'function') return getShoptetDataLayer();
  } catch {
    /* ignore */
  }
  return null;
}

/** @param {unknown} dl */
export function getCartLines(dl) {
  if (!dl || typeof dl !== 'object') return [];
  const o = /** @type {Record<string, unknown>} */ (dl);
  if (Array.isArray(o.cart)) return o.cart;
  if (Array.isArray(o.cartItems)) return o.cartItems;
  if (Array.isArray(o.items)) return o.items;
  return [];
}

export function skuStartsWithAny(sku, prefixes) {
  if (!sku || !Array.isArray(prefixes) || !prefixes.length) return false;
  const u = String(sku).toUpperCase();
  return prefixes.some(p => u.startsWith(String(p || '').toUpperCase()));
}

/**
 * 1 = digitální košík (první řádek), 2 = ostatní.
 * @returns {1 | 2 | null}
 */
export function getCartGoodsType(cfg, dl) {
  const lines = getCartLines(dl);
  if (!lines.length) return null;
  const code = lines[0]?.code;
  if (typeof code !== 'string') return null;
  const prefixes = cfg.classification?.digitalPrefixes ?? ['DIG_'];
  return skuStartsWithAny(code, prefixes) ? 1 : 2;
}

export function normalizePageTypeName(pageType) {
  if (typeof pageType !== 'string') return '';
  return pageType.replace(/-/g, '').toLowerCase();
}
